export const categoryPagePostPerPage = 16
